import { QueryClient } from '@tanstack/react-query'

/**
 * TanStack Query 的全局实例。
 *
 * ⚠ 流式(SSE)不走 Query —— 契约 §5.2 的流是长连接增量事件，
 *   Query 的缓存/重试模型套不上去。流式状态放 Zustand，见 README 技术栈表。
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 默认不自动重试：契约 §3 要求按 code 分支决定能不能重试，
      // 尤其 TRADE.RESULT_UNKNOWN 严禁重发(供应商侧可能已成功，会重复扣款)。
      // 具体重试策略由 api-client 在 M0 按 retryable 字段接管。
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
})
